export default __webpack_public_path__ + "static/media/html.ebfc51e4.svg";